// Registry of insertable effects. Adding a new effect = create a file in
// this folder, import it here, and append to the array.

import compressor from './compressor.js';
import distortion from './distortion.js';
import filter from './filter.js';
import chorus from './chorus.js';
import bitcrusher from './bitcrusher.js';
import limiter from './limiter.js';

export const FX_LIBRARY = [compressor, distortion, filter, chorus, bitcrusher, limiter];

const byId = new Map(FX_LIBRARY.map(fx => [fx.id, fx]));
export function getFx(id) { return byId.get(id); }
